export enum Nationality {
  American = 'usa',
  Mexican = 'mex',
  Other = 'other',
}
